import styled, { css } from "styled-components";
import { getImage } from "@nested/utils";
import { media } from "@nested/brand";
import { ButtonLink } from "@nested/component-library";

const SectionWrapper = styled.div`
  padding: 0 20px;
  ${media.desktop`
    padding-right: 0;
  `}
`;

const FloorPlan = styled.a`
  box-sizing: border-box;
  margin: 60px 0 10px 0;
  height: 250px;
  display: flex;
  width: 100%;

  ${media.tablet`
    height: auto;
    padding: 0;
  `};
  ${media.desktop`
    border: ${({ theme }) => theme.palette.hague40} solid 1px;
    border-radius: 20px;
    padding: 20px;
    margin: 0;
  `};
`;

const FloorPlanImage = styled.img`
  height: 100%;
  max-height: 400px;
  width: auto;
  margin: 0 auto;
  max-width: 100%;
  object-fit: contain;
`;

const DocumentLinks = styled.div`
  width: 100%;
  margin: 20px 0 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${media.tablet`
    justify-content: flex-start;
    a {
      margin-top: 20px;
    }
    a:first-child {
      margin-right: 20px;
    }
  `};
`;

const epcButton = css`
  margin-top: 10px;
`;

export const Floorplan = ({ floorPlanImageUrl, externalId, epcImageUrl }) => {
  const floorPlanUrl = getImage(
    `property-listings/${externalId}/${floorPlanImageUrl}?bg=white`,
  );

  return (
    <SectionWrapper>
      <FloorPlan href={floorPlanUrl}>
        <FloorPlanImage src={floorPlanUrl} alt="Floor plan" />
      </FloorPlan>

      <DocumentLinks>
        <ButtonLink to={floorPlanUrl}>View floor plan</ButtonLink>
        {epcImageUrl && (
          <ButtonLink
            css={epcButton}
            to={getImage(
              `property-listings/${externalId}/${epcImageUrl}?bg=white`,
            )}
          >
            View EPC certificate
          </ButtonLink>
        )}
      </DocumentLinks>
    </SectionWrapper>
  );
};
